import React, { useState } from 'react';
import {
  Container,
  TextField,
  Typography,
  Button,
  Box,
  Alert,
  Link, Backdrop, CircularProgress
} from '@mui/material';
import Header from '../components/layout/Header';
import { useSearchParams } from 'react-router-dom';

const Contact = () => {
    const [searchParams] = useSearchParams()
    const demande = searchParams.get('demande');
    const [form, setForm] = useState({
        name: '',
        email: '',
        message: '',
    });
    const [status, setStatus] = useState({ success: null, error: null });
    const [loading, setLoading] = useState(false);

    const handleChange = (e) => {
        setForm({ ...form, [e.target.name]: e.target.value });
    };

    const handleSubmit = async (e) => {
        e.preventDefault(); setLoading(true);
        setStatus({ success: null, error: null });

        try {
        const res = await fetch(`${process.env.REACT_APP_API_URL}/public/contact`, {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify(form),
        });

        const token = res.headers.get('x-auth-token');
        if (token) localStorage.setItem('token', token);
        

        if (!res.ok) throw new Error('Erreur serveur');
        setLoading(false);
        setStatus({ success: 'Message envoyé avec succès ✅', error: null });
        setForm({ name: '', email: '', message: '' });
        } catch (err) {
        setStatus({ success: null, error: 'Une erreur est survenue ❌' });
        }
    };

    return (
    <>
        <Header />
        <Container maxWidth="sm" sx={{ py: 6 }}>
        <Typography variant="h4" gutterBottom fontWeight="bold" textAlign="center">
            Contactez-nous
        </Typography>

        <Typography variant="body1" textAlign="center" color="text.secondary">
            Une question, une remarque, une demande spécifique ?
            <br />
            Vous pouvez nous écrire directement à :{' '}
            <Link href="mailto:contact@mygospelpass.com" underline="hover">
            contact@mygospelpass.com
            </Link>
        </Typography>

        <Box component="form" onSubmit={handleSubmit} sx={{ mt: 4 }} noValidate>
            <Box display="flex" flexDirection="column" gap={3}>
            <TextField
                label="Nom"
                name="name"
                value={form.name}
                onChange={handleChange}
                required
            />
            <TextField
                label="Email"
                name="email"
                type="email"
                value={form.email}
                onChange={handleChange}
                required
            />
            <TextField
                label="Message"
                name="message"
                value={form.message}
                onChange={handleChange}
                multiline
                rows={5}
                required
            />
            <Button type="submit" variant="contained" size="large">
                Envoyer
            </Button>
            </Box>
        </Box>

        {status.success && <Alert severity="success" sx={{ mt: 3 }}>{status.success}</Alert>}
        {status.error && <Alert severity="error" sx={{ mt: 3 }}>{status.error}</Alert>}
        </Container>
        <Backdrop open={loading}><CircularProgress/></Backdrop>
    </>
  );
};

export default Contact;
